<div [formGroup]="eligibilityForm">
  <input
    class="inputbox"
    type="text"
    formControlName="indentifier"
    [placeholder]="(customVariables$ | async)?.eligibility_identifier"
  />
  <mat-error
    *ngIf="this.eligibilityForm.invalid && this.eligibilityForm.dirty"
    [translate]="'JadeEligibilityCheck:MustBeValid'"
    role="alert"
  >
  </mat-error>
</div>
